document.querySelectorAll('.compare-btn').forEach(e => {
    e.addEventListener('click', function (event) {
        event.preventDefault();
        const id = e.dataset.product;
        const handle = e.dataset.handle;
    
        console.log(id);
        console.log(handle);

        // Retrieve existing handles from local storage or initialize an empty string
        const existingHandlesString = localStorage.getItem('compare_handles') || '';

        // Convert the comma-separated string to an array
        const existingHandles = existingHandlesString.split(',');

        // Check if the handle already exists in the array
        const existingHandleIndex = existingHandles.indexOf(handle);

        if (existingHandleIndex === -1) {
            // If the handle is not in the array, add it
            existingHandles.push(handle);

            console.log('Handle added in compare_handles.');
            // Update local storage with the modified array as a comma-separated string
            localStorage.setItem('compare_handles', existingHandles.join(','));
        } else {
            console.log('Handle already exists in compare_handles.');
        }

        existingHandles.forEach(e=> {
            if (e != '') {
                fetch(window.Shopify.routes.root + `products/${e}.js`)
                .then(response => response.json())
                .then(product => {
                    renderCompare(product);
                })
                .catch(error => {
                    console.error('Error fetching product:', error);
                });
            }
        })

        console.log(existingHandles.length)
        if (existingHandles.length > 1) {
            document.querySelector('.no-items').setAttribute('hidden','')
            document.querySelector('.compare-wrapper').removeAttribute('hidden')
        }
    });
});
      
function renderCompare(product) {
    const components = document.querySelector('.compare-components');
    const remove_row = document.querySelector('.compare-remove');
    const image_row = document.querySelector('.compare-image');
    const title_row = document.querySelector('.compare-title');
    const type_row = document.querySelector('.compare-type');
    const vendor_row = document.querySelector('.compare-vendor');
    const price_row = document.querySelector('.compare-price');

    const componentText = components.textContent
        .replace(/%url%/g, product.url)
        .replace(/%handle%/g, product.handle)
        .replace(/%image%/g, product.featured_image)
        .replace(/%title%/g, product.title)
        .replace(/%type%/g, product.type)
        .replace(/%vendor%/g, product.vendor)
        .replace(/%compare_price%/g, moneyFormatter(product.compare_at_price))
        .replace(/%price%/g, moneyFormatter(product.price))
        
    const html = new DOMParser().parseFromString(componentText, 'text/html');

    const removeEl = html.querySelector('[data-compare-handle]')
    const imageEl = html.querySelector('.image-item')
    const titleEl =  html.querySelector('.title-item')
    const typeEl =  html.querySelector('.type-item')
    const vendorEl =  html.querySelector('.vendor-item')
    const priceEl =  html.querySelector('.price-item')

    if (remove_row.querySelector(`[data-compare-handle="${product.handle}"]`)) return;
    // Append the new element to remove_row
    remove_row.insertAdjacentElement('beforeend',removeEl);
    image_row.appendChild(imageEl);
    title_row.appendChild(titleEl);
    type_row.appendChild(typeEl);
    vendor_row.appendChild(vendorEl);
    price_row.appendChild(priceEl);
}

function moneyFormatter(number) {
    let formattedNumber = (number / 100).toFixed(2).replace(/\B(?=(\d{3})+(?!\d))/g, ',').replace('.00', '');
    return formattedNumber;
}

class ButtonRemove extends HTMLElement {
    constructor() {
        super();
        // You should use addEventListener to attach an event listener to an element.
        this.addEventListener('click', this.initRemove.bind(this));
    }

    initRemove() {
        const handle = this.dataset.compareHandle;

        // Retrieve existing handles from local storage or initialize an empty string
        const existingHandlesString = localStorage.getItem('compare_handles') || '';

        // Convert the comma-separated string to an array
        const existingHandles = existingHandlesString.split(',');

        // Check if the handle already exists in the array
        const existingHandleIndex = existingHandles.indexOf(handle);

        if (existingHandleIndex !== -1) {
            // If the handle is not in the array, add it
            
            document.querySelector('.compare-products').querySelectorAll(`[data-compare-handle="${existingHandles[existingHandleIndex]}"]`).forEach(e=> {
                e.remove()
            })

            existingHandles.splice(existingHandleIndex, 1);
            localStorage.setItem('compare_handles', existingHandles.join(','));
            console.log(existingHandles.length)

            if (existingHandles.length == 1) {
                document.querySelector('.no-items').removeAttribute('hidden')
                document.querySelector('.compare-wrapper').setAttribute('hidden','')
            }
        }

    }
}

// Register the custom element
customElements.define('button-remove', ButtonRemove);


var compareWrapper = document.querySelector('.compare-wrapper');

compareWrapper?.addEventListener('wheel', function(event) {
    // Detect the direction of the scroll
    var direction = event.deltaY > 0 ? 1 : -1;

    // Adjust the scroll position based on the direction
    compareWrapper.scrollLeft += direction * 80; // You can adjust the scrolling speed here
   
    // Prevent the default behavior (page scrolling) to avoid conflicts
    event.preventDefault();
});


// Get all anchor elements
var anchorElements = document.querySelectorAll('a');

// Loop through the anchor elements
anchorElements.forEach(function(anchor) {
    // Check if the href attribute contains #
    if (anchor.getAttribute('href') && anchor.getAttribute('href').includes('#')) {
        anchor.addEventListener('click', function(event) {
            event.preventDefault();

            // Get the target ID from the href
            var targetId = anchor.getAttribute('href').substring(1); // Remove the #

            // Check if an element with the target ID exists in the DOM
            var targetElement = document.getElementById(targetId);

            if (targetElement) {
                // Define an offset (adjust this value as needed)
                var offsetTop = 50; // Change this to your desired offset

                // Scroll to the target element with the specified offset
                window.scrollTo({
                    top: targetElement.offsetTop - offsetTop,
                    behavior: 'smooth' // You can change this to 'auto' for an instant scroll
                });
            }
        });
    }
});